// extracted by mini-css-extract-plugin
module.exports = {"pcWrap":"pcWrap___1yyIN","mobileWrap":"mobileWrap___2Et1O"};